import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/WalletOverview.tsx");
